goog.provide('el8.app.onboarding.activateAccount');

goog.require('el8.app.onboarding.TestAccountDialog');
goog.require('el8.template.app.onboarding.activateAccount');



el8.app.onboarding.activateAccount = (function() {

    var that = new el8.app.onboarding.TestAccountDialog({
        autoHeight: true,
        position: 'center',
        width: 500,
        modal: true,
        title: 'Subscribe to ElationEMR',
        contentFn: el8.template.app.onboarding.activateAccount.content,
        showXButton: true
    });

    var super_show = that.show;
    that.show = function() {
        super_show.call(that);
        that._showFresh();
    };

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that._bindTriggers();
    };

    that._bindTriggers = function() {
        that.getContentElt().on('click', '.submit-trigger',  function() {
            that._submitRequest();
        }).on('click', '.reset-form-trigger',  function() {
            that._showFresh();
        }).on('click', '.learn-more',  function() {
            window.open("https://www.elationhealth.com/pricing/?utm_campaign=in_app&utm_source=learn_more","_blank");
        });
    };

    that._submitRequest = function() {
        that._showInProgress();

        var campaignData = {};
        campaignData['utm_campaign'] = '1.passport.activate';
        campaignData['utm_medium'] = 'emr';
        campaignData['utm_source'] = 'el8';
        campaignData['utm_content'] = 'banner';

        $.el8_ajax({
            type: 'POST',
            url: '/requestSubscription/',
            data: JSON.stringify(campaignData),
            success: function() { that._showSuccess(); },
            error: function() { that._showError(); }
        });
    };

    /**
     * Helper methods
     */
    that._showFresh = function() {
        $('#activate-account-container', that.getContentElt()).html(
            el8.template.app.onboarding.activateAccount.freshContent()
        ).removeClass('imageLoading');
        that.adjustPosition();
    };
    that._showInProgress = function() {
        $('#activate-account-container', that.getContentElt()).empty().addClass('imageLoading');
    };
    that._showSuccess = function() {
        $('#activate-account-container', that.getContentElt()).html(
            el8.template.app.onboarding.activateAccount.successContent()
        ).removeClass('imageLoading');
        that.adjustPosition();
    };
    that._showError = function() {
        $('#activate-account-container', that.getContentElt()).html(
            el8.template.app.onboarding.activateAccount.errorContent()
        ).removeClass('imageLoading');
        that.adjustPosition();
    };

    return that;

})();
